const stampBgm = {
  beforeCreate() {
    // `this.$bgm` is a getter, not a copy of window.CloudzetAudio.
    // Changing the language replaces window.CloudzetAudio with a new Howl.
    // A page that is already open (e.g. Welcome, where the menu lives) would
    // keep playing the old one if we copied it here once; the getter makes
    // every call use whatever is on window right now.
    Object.defineProperty(this, '$bgm', { get: () => window.CloudzetAudio });
  },
  data: () => ({
    playingAnalyzing: null,
  }),
  methods: {
    playPositive() {
      this.$bgm.play('positive');
    },
    playNegative() {
      this.$bgm.play('negative');
    },
    playScanning() {
      this.$bgm.play('scanning');
    },
    playAnalyzing() {
      this.playingAnalyzing = this.$bgm.play('analyzing');
      this.$bgm.once(
        'end',
        () => {
          this.playingAnalyzing = null;
        },
        this.playingAnalyzing
      );
    },
    stopAnalyzing() {
      if (typeof this.playingAnalyzing !== 'number') return;

      this.$bgm.stop(this.playingAnalyzing);
    },
    playCountDown() {
      this.$bgm.play('countdown');
    },
    playCountDownLast() {
      this.$bgm.play('last_countdown');
    },
  },
};

export default stampBgm;
